import { ListTasksSkeletonComponent } from './list-tasks-skeleton.component';

export default angular
  .module('sfMobile.components.task-skeleton', [
    'sfMobile.components.task-item-skeleton',
  ])
  .component('sfListTasksSkeleton', ListTasksSkeletonComponent).name;
